import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useTextEnableLandlineStepsContext } from 'pages/settings/pages/numbers/pages/TextEnableLandline/context/useTextEnableLandlineStepsContext'
import { VerifyNumberCommon } from 'pages/settings/ui/VerifyNumberCommon'

export const VerifyNumber = observer(() => {
  const { verifyNumberStore } = useTextEnableLandlineStepsContext()
  const { disposeStep } = verifyNumberStore

  useEffect(() => {
    return () => {
      disposeStep()
    }
  }, [])

  return <VerifyNumberCommon store={verifyNumberStore} />
})
